<!-- eslint-disable max-len -->
<template>
  <li class="nav-item dropdown active" ref="parent">
    <a
      class="nav-link dropdown-toggle"
      href="#"
      id="assetEnvironmentMenu"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      @click="shouldDisplayDropdown = !shouldDisplayDropdown"
      aria-expanded="false">
      Assets
    </a>
    <div ref="dropdown" :class="'dropdown-menu navbar-bg ' + (shouldDisplayDropdown ? 'show' : '')" aria-labelledby="assetEnvironmentMenu">
      <div class="env-dropdown-content">
        <b-form-group label="">
          <b-checkbox-group v-model="selected" :options="options" @change="onEnabledChanged">
          </b-checkbox-group>
        </b-form-group>
      </div>
    </div>
  </li>
  <!-- old version, switch this back on to add it to other places
  <b-dropdown id="env-dropdown" text="Active Asset Environments" style="margin-top: 2px; width: 200px;">
    <div class="env-dropdown-content">
      <b-form-group label="">
        <b-checkbox-group v-model="selected" :options="options" @change="onEnabledChanged">
        </b-checkbox-group>
      </b-form-group>
    </div>
  </b-dropdown>
  -->
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  async mounted() {
    this.loading = true;
    try {
      // Ensure the asset data is loaded
      await this.loadAssetData();
      this.selected.length = 0;
      // eslint-disable-next-line no-restricted-syntax
      for (const k of this.getEnabledAssetManifests) {
        this.selected.push(k);
        console.log(k);
      }
      this.unsubscribe = this.$store.subscribe((mutation) => {
        // console.log('updating');
        if (!this.isMutationSource && mutation.type.startsWith('setAssetManifestEnabled')) {
          this.selected.length = 0;
          // eslint-disable-next-line no-restricted-syntax
          for (const k of this.getEnabledAssetManifests) {
            this.selected.push(k);
            console.log(k);
          }
          this.$forceUpdate();
        }
      });
    } catch (ex) {
      console.error(ex);
      this.$set(this, 'error', 'Failed to load asset environments.  Please try again later.  If the issue persists, please notify the developers.');
    }

    this.loading = false;
  },

  beforeDestroy() {
    this.unsubscribe();
  },

  data() {
    return {
      shouldDisplayDropdown: false,
      error: null,
      loading: false,
      selected: [],
      unsubscribe: null,
      isMutationSource: false
    };
  },
  computed: {
    ...mapGetters([
      'getAssetEnvironments',
      'isAssetManifestEnabled',
      'getEnabledAssetManifests'
    ]),

    options() {
      return this.getAssetEnvironments;
    }
  },
  methods: {
    ...mapActions([
      'loadAssetData'
    ]),
    ...mapMutations([
      'setAssetManifestEnabledListFromNameList'
    ]),

    onEnabledChanged(checked) {
      console.log(checked);
      this.isMutationSource = true;
      this.setAssetManifestEnabledListFromNameList(checked);
      this.isMutationSource = false;
      console.log(this.$store.state.bladeAssets.enabled);
    }
  }
};
</script>

<style lang="scss" scoped>
.env-dropdown-content
{
  padding: 10px;
  width: 250px;
  color: var(--navBarTextColor) !important;
}

header {
  height: 40px;
}
.navbar-root {
  height: 100%;
  padding-top: 4px;

  .nav-link {
    color: var(--navBarTextColor) !important;
    margin: 0 2px;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
  }
  .nav-link:hover {
    // background-color: rgba(0, 0, 7, 0.2);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-item {
    color: var(--navBarTextColor) !important;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
  }
  .dropdown-item:hover {
    // background-color: rgba(0, 0, 7, 0.4);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-divider {
    border-color: var(--primaryColor);
  }

  .username {
    text-transform: unset !important;
  }
}

.navbar-bg {
  // background-color: rgba(0, 0, 7, 0.76);
  background-color: var(--navBarDropdownColor);
}

.navbar-logo {
  width: 50%;
  height: 100%;
  position: relative;
}
.logo-link {
  outline-color: white;
  height: 100%;
  margin-left: 10px;
}
.logo {
  height: 100%;
  max-width: 100%;
  object-fit: contain;
}
.navbar-brandText {
  color: var(--navBarTextColor);
  outline-color: white;
  width: auto;
  height: 100%;
  margin: auto;
  margin-top: -2px;
  text-align: center;
  white-space: nowrap;
  font-size: 16pt;
  font-weight: bold;
  font-family: unset;
  // font-weight: normal;
  // font-family: "Book Antiqua", Palatino, serif;
}
.navbar-actionItems {
  width: 50%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.navbar-brand:focus, .nav-item a:focus {
  outline-color: white;
}
.title {
  color: var(--primaryColor);
  background-color: white;
  font-size: 72px;
  font-weight: bold;
  border-radius: 0;
  margin: 0;
  padding: 40px;
}
.demo-links {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
}
.demo-link {
  color: black;
  padding: 2px 5px;
}
.demo-link:hover, .demo-link:focus {
  text-decoration: none;
  color: var(--primaryColor);
}
.demo-link:focus {
  outline: none;
}

.dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(180deg);
}
.dropdown-toggle:after {
  transition: 0.4s;
}

.navbar-item-divider {
  //width: 1.3px;
  //background-color: var(--primaryColor);
  // Doing it with border rather than width because borders tend to render thin lines more cleanly
  // across different browsers
  height: 72%;
  width: 0px;
  margin: 5px 4px;
  border-right: 1px solid var(--primaryColor);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/display/ActiveAssetEnvironmentSelector.vue